import CompanyLogo from "assets/images/companyLogo.svg";
import favicon from "assets/images/favicon.ico";

export const companyDetails = {
    companyName: "ITER-SubVendor",
    companyLogo: CompanyLogo,
    favicon:favicon
}